import {
  RECEIVE_USER,
  RECEIVE_USER_NOSSA,
  LOGOUT_USER,
  ERROR_USER,
  REMOVE_USER_ERRORS,
  RECEIVE_TOKEN,
  LOADING_USER,
  LOADING_USER_AUTHENTICATION,
  REQUEST_USER_LINK_ACCOUNT,
  RECEIVED_USER_LINK_ACCOUNT,
  ERROR_USER_LINK_ACCOUNT,
  LOGOUT_USER_ACTION,
  RESET_USER_ACTION,
  SET_IS_EX_SUBSCRIBER
} from '../actions/userActions';

const initialState = {
  user: {},
  receivedToken: false,
  authenticated: false,
  loadingUserAuthentication: true,
  loadingUser: false,
  errors: null,
  origin: false,
  loginType: false,
  loginAttempts: 0,
  linkAccount: {},
  linkAccountError: null,
  loadingLinkAccount: false,
  userAction: '',
  uid: null,
  isExSubscriber: false
};

export default function UserReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_USER:
      return {
        ...state, user: action.user, authenticated: action.authenticated, loadingUser: false, errors: null, receivedToken: action.receivedToken
      };
    case RECEIVE_USER_NOSSA:
      return {
        ...state, user: action.user, token: action.token, uid: action.uid, receivedToken: action.receivedToken, authenticated: action.authenticated, loadingUser: false, errors: null
      };
    case RECEIVE_TOKEN:
      return {
        ...state, token: action.token, errors: null, receivedToken: action.receivedToken, origin: action.origin, loginType: action.loginType, loginAttempts: 0
      };
    case LOGOUT_USER:
      return {
        ...state, user: action.user, authenticated: action.authenticated, errors: null
      };
    case LOGOUT_USER_ACTION:
      return {
        ...state, userAction: action.userAction
      };
    case RESET_USER_ACTION:
      return {
        ...state, userAction: ''
      };
    case LOADING_USER:
      return {
        ...state, loadingUser: action.loadingUser
      };
    case LOADING_USER_AUTHENTICATION:
      return {
        ...state, loadingUserAuthentication: action.loadingUserAuthentication
      };
    case REQUEST_USER_LINK_ACCOUNT:
      return {
        ...state, cpf: action.cpf, loadingLinkAccount: action.loadingLinkAccount
      };
    case RECEIVED_USER_LINK_ACCOUNT:
      return {
        ...state, linkAccount: action.linkAccount, linkAccountError: null, loadingLinkAccount: action.loadingLinkAccount
      };
    case ERROR_USER:
      return {
        ...state, errors: action.errors, receivedToken: false, loginAttempts: state.loginAttempts + 1
      };
    case ERROR_USER_LINK_ACCOUNT:
      return {
        ...state, linkAccountError: action.linkAccountError, loadingLinkAccount: action.loadingLinkAccount
      };
    case REMOVE_USER_ERRORS:
      return {
        ...state, errors: null, receivedToken: false
      };
    case SET_IS_EX_SUBSCRIBER:
      return {
        ...state, isExSubscriber: action.isExSubscriber
      };
    default:
      return state;
  }
}
